import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { goToAppStore } from "../lib/api";

const SERVICES = [
  {
    n: "01",
    title: "One-on-One Messaging Consultations",
    desc: "Tailored advice through direct messaging from certified stylists. Discuss your needs and get professional recommendations without leaving home.",
    img: "https://images.unsplash.com/photo-1562322140-8baeececf3df?w=1000&q=80",
  },
  {
    n: "02",
    title: "Style & Texture Assessment",
    desc: "A comprehensive review of your current look and hair texture. Our experts provide insights to elevate your personal style and confidence.",
    img: "https://images.unsplash.com/photo-1595475693741-b445b025aec7?w=1000&q=80",
  },
  {
    n: "03",
    title: "Hair Care & Scalp Routine Guidance",
    desc: "In-depth advice on products and routines tailored to your hair type, helping you maintain healthy, resilient, beautiful hair.",
    img: "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?w=1000&q=80",
  },
  {
    n: "04",
    title: "Custom Colour & Cut Recommendations",
    desc: "Personalised colour formulas and cut direction you can take straight to your salon, matched to your face shape and lifestyle.",
    img: "https://images.unsplash.com/photo-1629397685944-7073f5589754?w=1000&q=80",
  },
];

export const Services = () => {
  return (
    <section id="services" className="py-16 md:py-24 bg-stylist-bg2">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
          <div>
            <span className="eyebrow">Discover our unique offerings</span>
            <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-stylist-ink">
              Our Services
            </h2>
          </div>
          <p className="max-w-sm text-sm text-stylist-ink font-semibold">
            Senior Stylist is an on-demand, message-based subscription service.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 md:gap-8">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group relative bg-white border border-stylist-border rounded-lg overflow-hidden hover:shadow-2xl hover:-translate-y-1 hover:border-stylist-gold/40 transition-all duration-500"
              data-testid={`service-card-${s.n}`}
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-stylist-ink/40 to-transparent" />
              </div>
              <div className="p-6 md:p-8">
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-serif text-xl md:text-2xl text-stylist-ink leading-snug">
                    {s.title}
                  </h3>
                  <ArrowUpRight className="w-5 h-5 text-stylist-muted group-hover:text-stylist-gold group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all shrink-0 mt-1" />
                </div>
                <p className="mt-3 text-sm text-stylist-ink2 leading-relaxed">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={goToAppStore}
            data-testid="services-cta-chat"
            className="group inline-flex items-center justify-center gap-2 rounded-full bg-stylist-ink text-white px-7 py-4 text-sm hover:bg-stylist-gold transition-colors duration-300"
          >
            Subscribe today
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </button>
          <span className="text-sm text-stylist-muted">Download the app and subscribe to speak with a specialist.</span>
        </div>
      </div>
    </section>
  );
};
